import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/common';

export function NotFoundPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="flex h-screen items-center justify-center">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-primary mb-2">404</h1>
        <p className="text-lg font-medium text-admin-text mb-1">{t('errors.pageNotFound')}</p>
        <p className="text-sm text-admin-text-secondary mb-6">
          {t('errors.pageNotFoundDescription')}
        </p>
        <Button onClick={() => navigate('/', { replace: true })}>{t('actions.back')}</Button>
      </div>
    </div>
  );
}
